import '../MainFrame.css';
import "./ayuda.css"



export default function Contact(props) {
    return(
        <div className='frame'>
            <div className='ayuda-title2'>
                <h2>Contactanos</h2>
            </div>
            <div className='contact-form-container'>
                <form action="#" className='contact-form'>
                    <label >Nombre:</label>
                        <input type="text" className='contact-input'/>
                    <label >DNI:</label>
                        <input type="number" className='contact-input'/>
                    <label >Correo Electronico:</label>
                        <input type="email" className='contact-input'/>
                    <label >Descripcion del problema:</label>
                        <textarea className='textarea-contact'/>
                    <button style={{width:"5rem"}} className='green-btn sethoverdark setpointer'>
                        Enviar
                    </button>
                </form>        
            </div>
        </div>
    );
}